module.exports = __webpack_public_path__ + "img/member-active.656e5433.png";